if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this._updateWeglotText();
              
              if (window.Weglot && typeof window.Weglot.on === 'function') {
                window.Weglot.on('languageChanged', () => {
                   this._updateWeglotText();
                });
              }
            }

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      _updateWeglotText() {
        if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
          const currentLang = window.Weglot.getCurrentLang().toLowerCase();
          const isItalian = currentLang.includes('it');
          
          // Manually set translation for AJAX content
          const headingSpan = this.querySelector('.section__heading span') || this.querySelector('.section__heading');
          if (headingSpan) {
            headingSpan.textContent = (isItalian ? 'POTREBBE INTERESSARTI ANCHE' : 'YOU MAY ALSO LIKE');
          }
          
          const atcButtons = this.querySelectorAll('button[name="add"] span');
          atcButtons.forEach(span => {
            const text = span.textContent.trim().toUpperCase();
            if (text === 'AGGIUNGI AL CARRELLO' || text === 'ADD TO CART' || text === 'ADD TO CART ADD TO CART') {
              span.textContent = (isItalian ? 'AGGIUNGI AL CARRELLO' : 'ADD TO CART');
            }
          });

          window.Weglot.initialize();
        }
      }
    }
  );
}
